import Home from './Home';
import './Home.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Actions
import { setLoading } from '../../redux/loading/actions';
import { createNewUserOrSignIn } from "../../redux/auth/actions";

// Connect
const mapStateToProps = (state) => {
  const isAuthenticated = (
       state.auth.token !== undefined         && state.auth.token !== null
    && state.auth.userId !== undefined        && state.auth.userId !== null
    && state.loyalty.cardNumber !== undefined && state.loyalty.cardNumber !== null
  );

  return {
    isAuthenticated: isAuthenticated,
    // seenTutorial: (window.localStorage.getItem("adjoy_seenTutorial") === 'true')
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loading
    createNewUserOrSignIn,
    setLoading,
  }, dispatch);
}

const ConnectedHome = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Home));

export default ConnectedHome;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js